<template>
  <div class="m-box">
    <div class="talk-title">话题</div>
    <div class="talk-box">
      <div class="talk-top">
        <div class="talk-sumtitle">{{ topicData.name }}</div>
        <div class="talk-num">{{ total }}篇内容</div>
        <div class="talk-summary">
          {{ topicData.intro }}
        </div>
      </div>
      <div
        class="talk-list"
        v-infinite-scroll="getDataList"
        infinite-scroll-disabled="busy"
        infinite-scroll-
        distance="10"
      >
        <div
          class="item"
          v-for="(item, i) in topicList"
          :key="i"
          @click="toDetail(item.id)"
        >
          <div :class="item.imgStr.length == 1 && !item.videoUrl ? 'pic1' : ''">
            <div class="title">
              {{ item.title }}
            </div>
            <img v-if="item.imgStr.length == 1" :src="item.imgStr[0]" alt="" />
          </div>
          <div
            class="item-video"
            v-if="item.videoUrl && item.imgStr.length == 0"
          >
            <iframe
              width="100%"
              height="196"
              :src="
                'https://player.dahe.cn/dh_player/?videosrc=' + item.videoUrl
              "
              frameborder="0"
              allowfullscreen
            >
            </iframe>
          </div>
          <div class="item-img" v-if="item.imgStr.length > 1">
            <img
              v-for="(itemImg, index) in item.imgStr"
              :key="index"
              :src="itemImg"
              alt=""
            />
          </div>
          <div class="num-box">
            <span class="pv-num">{{ item.pv }}阅读</span>
            <span class="dis-num">{{ item.discussNum }}评论</span>
            <span class="date">{{ item.formatTime }}</span>
          </div>
        </div>
      </div>
      <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
      <div v-else class="loading">正在加载中，请稍等…</div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
export default {
  name: "MSignList",
  directives: { infiniteScroll },
  data() {
    return {
      id: this.$route.params.id,
      current: 1,
      size: 10,
      topicData: [],
      topicList: [],
      total: "",
      busy: false,
      dataLoadNomore: false,
    };
  },
  methods: {
    getTopicDetail() {
      this.$api
        .topicAppDetail({
          id: this.id,
        })
        .then((res) => {
          this.topicData = res.data.data;
          console.log(res.data.data.name)
          this.wxshare(res.data.data.name, '');
        });
    },
    getDataList() {
      this.busy = true;
      this.$api
        .mActivetyList({
          topicId: this.id,
          current: this.current,
          size: this.size,
          type: 0,
        })
        .then((res) => {
          this.total = res.data.data.total;
          res.data.data.records.forEach((item, index) => {
            if (item.imgStr) {
              item.imgStr = item.imgStr.split(",");
            } else {
              item.imgStr = [];
            }
          });
          this.topicList = this.topicList.concat(res.data.data.records);
          if (res.data.data.current < res.data.data.pages) {
            this.current += 1;
            this.busy = false;
            this.dataLoadNomore = false;
          } else {
            this.dataLoadNomore = true;
          }
        });
    },
    toDetail(tid) {
      window.open("/m/detail/" + tid + "/" + 0);
    },
    wxshare(t, d) {
      let sharelink = window.location.href;
      let sharetitle = t;
      let shareimgUrl = "https://4g.dahe.cn/resources/img/wxlogo1.png";
      let sharedes = d;
      let result = fetch(
        "https://share.dahe.cn/share/yanyu?url=" + encodeURIComponent(sharelink)
      );
      result
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          let text = data.object;

          /* 微信 */
          wx.config({
            debug: false, // 开启调试模式。
            appId: text.appId, // 必填，公众号的唯一标识
            timestamp: text.timestamp, // 必填，生成签名的时间戳
            nonceStr: text.nonceStr, // 必填，生成签名的随机串
            signature: text.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
          });

          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // console.log(res)
            },
          });

          //需在用户可能点击分享按钮前就先调用
          wx.ready(function () {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              desc: sharedes, // 分享描述
              success: function () {
                // 设置成功
              },
            });

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });

          wx.error(function (res) {
            console.log("err: " + res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(function (ex) {
          console.log("failed", ex);
        });
    },
  },
  created() {
    this.getTopicDetail();
  },
};
</script>

<style scoped lang="scss">
.m-box {
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  height: auto;
  background: #e8f3ff;
  .talk-title {
    width: 100%;
    height: 13.333vw;
    font-size: 4.8vw;
    font-weight: 500;
    color: #333333;
    line-height: 16vw;
    text-align: center;
    background: #ffffff;
  }
  .talk-box {
    width: 100%;
    .talk-top {
      width: 100%;
    //   height: 54.4vw;
      padding: 3.733vw;
      .talk-sumtitle {
        font-size: 4.8vw;
        font-weight: 600;
        color: #333333;
        line-height: 6.666vw;
      }
      .talk-num {
        font-size: 4vw;
        font-weight: 400;
        color: #666666;
        line-height: 5.6vw;
        margin-top: 1.333vw;
      }
      .talk-summary {
        width: 100%;
        // height: 32vw;
        font-size: 4vw;
        font-weight: 400;
        color: #333333;
        line-height: 6.4vw;
        margin-top: 1.333vw;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
      }
    }
    .talk-list {
      width: 100%;
      padding: 3.467vw;
      background: #ffffff;
      border-radius: 4vw 4vw 0 0;
      .item {
        width: 100%;
        padding: 3.2vw 0;
        border-bottom: 0.267vw solid #e5e5e5;
        .title {
          width: 100%;
          font-size: 4vw;
          font-weight: 600;
          color: #333333;
          line-height: 5.6vw;
          text-align: justify;
        }
        .pic1 {
          display: flex;
          justify-content: space-between;
          img {
            width: 26.667vw;
            height: 21.333vw;
            margin-left: 4vw;
          }
        }
        .item-video {
          width: 100%;
          margin-top: 2.667vw;
        }
        .item-img {
          margin-top: 2.667vw;
          width: 100%;
          display: flex;
          justify-content: space-between;
          img {
            width: 29.867vw;
            height: 25.6vw;
          }
        }
        .num-box {
          width: 100%;
          font-size: 3.467vw;
          font-weight: 400;
          color: #999999;
          line-height: 4.8vw;
          margin-top: 2.667vw;
          span {
            margin-right: 3.733vw;
          }
        }
      }
    }
  }
  .loading {
    width: 100%;
    height: 6.933vw;
    background: url("../../assets/images/loading-icon.png") no-repeat 31.733vw
      center;
    font-size: 2vw;
    font-weight: 400;
    color: #666666;
    text-align: center;
    line-height: 5.6vw;
    background: #ffffff;
  }
  .loading-all {
    width: 100%;
    height: 6.933vw;
    font-size: 2vw;
    font-weight: 400;
    color: #666666;
    text-align: center;
    line-height: 5.6vw;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/m/Topic.vue